import { StacktraceScriptType } from '../types';
import { last } from './general-utils';
const scriptRegexs = [{
  scriptType: StacktraceScriptType.WIX_SERVICE,
  regex: () => /\/services\/([^/]+)\/([^/]+)\//
}, {
  scriptType: StacktraceScriptType.WIX_APP,
  regex: () => /apps\.wix\.com\/([^/]+)\//
}, {
  scriptType: StacktraceScriptType.WIX_CHAT,
  regex: () => /unpkg-semver\/(wix-chatbot-widget)\//
}, {
  scriptType: StacktraceScriptType.BROWSER_EXTENSION,
  regex: () => /^chrome-extension:/
}];
export const extractArtifactDataFromScriptUrl = url => {
  return scriptRegexs.reduce((res, _ref) => {
    let {
      scriptType,
      regex
    } = _ref;
    if (!res) {
      const match = regex().exec(url);
      if (match) {
        const [, artifactId, artifactVersion] = match;
        res = {
          artifactId,
          artifactVersion,
          scriptType
        };
      }
    }
    return res;
  }, null);
};
export const fullArtifactIdToArtifactId = fullArtifactId => {
  if (typeof fullArtifactId !== 'string') {
    return '';
  }
  return last(fullArtifactId.split('.')) || '';
};
export const getArtifactDataFromBaseParams = baseParams => {
  const {
    fullArtifactId,
    artifactVersion
  } = baseParams;
  return {
    artifactId: fullArtifactIdToArtifactId(fullArtifactId),
    artifactVersion,
    scriptType: StacktraceScriptType.WIX_SERVICE
  };
};
export const isSameArtifact = (artifactData1, artifactData2) => artifactData1.artifactId === artifactData2.artifactId;
export const isArtifactMismatch = (currentArtifactData, stackTraceArtifactsData) => stackTraceArtifactsData.length > 0 && currentArtifactData.artifactId !== stackTraceArtifactsData[0].artifactId;
export const getFirstMatchingArtifact = (artifactData, stackTraceArtifactsData) => {
  for (const artifact of stackTraceArtifactsData) {
    const {
      artifactId
    } = artifact;
    if (artifactId === artifactData.artifactId) {
      return artifact;
    }
  }
  return null;
};
//# sourceMappingURL=artifact-utils.js.map